import { Role } from "../../../src/app/models/role.enum";

export const SKIP_LOADER_URLS = ["file-handler/upload", "file-handler/process", "csv/files", "analytics/events"];
export const FILE_UPLOAD_STATUS = {
  IN_PROGRESS: "In Progress",
  FILE_PROCESSING_FAILED: "File Processing Failed",
  FILE_PROCESSING_TIMED_OUT: "File upsert was not completed. Please re-upload the file",
  FAILED_TO_UPLOAD: "Failed to upload the file",
} as const;


export const DASHBOARD_ITEMS = [
  {
    id: 24,
    name: "View File Status",
    description: "",
    icon: "file_status_pricing_engine",
    link: "file-upload",
    disabled: true,
    favorite: false,
    cardKey: "upload_status",
  },
  {
    id: 24,
    name: "Upload Files",
    description: "",
    icon: "upload_pricing_engine",
    link: "file-upload",
    disabled: true,
    favorite: false,
    cardKey: "file_upload",
  },
  {
    id: 6,
    name: "Contract Pricing",
    description: "View Contracts pricing details",
    icon: "contract_pricing",
    link: "price/pricing-information",
    disabled: true,
    favorite: false,
    cardKey: "Contract",
  },
  {
    id: 6,
    name: "Project Pricing",
    description: "View Projects pricing details",
    icon: "project_pricing",
    link: "price/pricing-information",
    disabled: true,
    favorite: false,
    cardKey: "Project",
  },
  {
    id: 6,
    name: "Spot Pricing",
    description: "View Spot pricing details",
    icon: "Spot_pricing",
    link: "price/pricing-information",
    disabled: true,
    favorite: false,
    cardKey: "spot_standard",
  },
  {
    id: 6,
    name: "New Customer Pricing",
    description: "View New customer pricing details",
    icon: "new_customer_pricing",
    link: "price/pricing-information",
    disabled: true,
    favorite: false,
    cardKey: "spot_new_customer",
  },
  {
    id: 6,
    name: "Customer Owned Pricing",
    description: "View customer owned pricing details",
    icon: "customer_owned_pricing",
    link: "price/pricing-information",
    disabled: true,
    favorite: false,
    cardKey: "spot_customer_owned",
  },
  {
    id: 14,
    name: "Rate Card",
    description: "View Rate Card",
    icon: "view_rate_card_dashboard",
    link: "rate-card/view-rate-card",
    disabled: true,
    favorite: false,
    cardKey: "rate_card_view",
  },
  {
    id: 6,
    name: "Partner Pricing",
    description: "View partner pricing details",
    icon: "partner_pricing",
    link: "price/pricing-information",
    disabled: true,
    favorite: false,
    cardKey: "Partner",
  },
];

export const UPDATE_TYPE = [
  "All",
  "Create",
  "Update",
  "Delete",
]

export const ALLOWED_EXPIRED_FILTER_AGREEMENT_TYPES = [
  "Project",
  "Contract",
  "Partner",
];


export const MENU_ROLE_ACCESS_MAP = {
  1: [], // Home - available to all roles
  26:[Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER, Role.RATE_CARD_MAINTAINER, Role.COMPETITOR_MAINTAINER], // Export Files - Rate card viewer excluded
  28: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER],

  // Master Data
  2: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER],
  17: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER], 18: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER], 19: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER],
  20: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER], 21: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER], 22: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER], 23: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER],
  33: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER], // Pricing Territory
  34: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER], // Zip Territory

  // Pricing Tool
  3: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  // 5: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  6: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  7: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  8: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  9: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  10: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  11: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  12: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  13: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],

  // Pricing Engine V2
  35: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  36: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Act Size Factor
  37: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Segment Factor V2
  38: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Status Factor
  39: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Unit Discount Factor
  40: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Phoenix Duration Factor
  41: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Pricing Density Zip Mileage
  42: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Last Paid Price (LPP)
  43: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Cost of Supplies
  44: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Cost Variable By Branch
  45: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Pricing Information V2
  49: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Campaign Margin

  // Fence Pricing
  46: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],
  47: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Stock Prices
  48: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER], // Non Stock Prices

  // Rate Card
  4: [Role.ADMIN, Role.RATE_CARD_MAINTAINER, Role.RATE_CARD_VIEWER, Role.COMPETITOR_MAINTAINER],
  14: [Role.ADMIN, Role.RATE_CARD_MAINTAINER, Role.RATE_CARD_VIEWER], // View Rate Card
  15: [Role.ADMIN, Role.COMPETITOR_MAINTAINER], // Competitor
  16: [Role.ADMIN, Role.RATE_CARD_MAINTAINER], // Volume
  29: [Role.ADMIN, Role.RATE_CARD_MAINTAINER], // Median
  // 16: [Role.ADMIN, Role.RATE_CARD_MAINTAINER, Role.COMPETITOR_MAINTAINER], // Upload

  // Upload
  24: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER, Role.RATE_CARD_MAINTAINER, Role.COMPETITOR_MAINTAINER],

  // Role Permissions
  25: [Role.ADMIN], // Manage Permissions - admin only

  // Permit Fee
  27: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],

  // Pricing Validation
  30: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER, Role.CONTRACT_PRICE_MAINTAINER],

  // DB Sync - Admin and Price Card Maintainer only (non-production environments)
  31: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER],

  // Analytics - Admin and Rate Card Maintainer only
  32: [Role.ADMIN,Role.RATE_CARD_MAINTAINER],
};

// Pricing Validation Options
export const ORDER_TYPE_OPTIONS = [
  { value: 'Recurring', label: 'Recurring' },
  { value: 'One-time', label: 'One-time' }
];

export const PRICING_TYPE_OPTIONS = [
  { value: 'spot_standard', label: 'Spot' },
  { value: 'spot_new_customer', label: 'New Customer' }
];

export const DURATION_OPTIONS = [
  { value: '1 week', label: '1 week' },
  { value: '2 weeks', label: '2 weeks' },
  { value: '3 weeks', label: '3 weeks' },
  { value: '4 weeks', label: '4 weeks' },
  { value: '5-12 weeks', label: '5-12 weeks' },
  { value: '13-24 weeks', label: '13-24 weeks' },
  { value: '25-52 weeks', label: '25-52 weeks' },
  { value: '53-104 weeks', label: '53-104 weeks' },
  { value: '>105 weeks', label: '>105 weeks' }
];

export const TIER_OPTIONS = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'D', label: 'D' }
];
